import React from 'react';
import styles from '../styles/components/Modal.module.css';
import { ActionButton } from './ActionButton';
import crossIcon from '../assets/cross_blue.svg';
import { RemoveScroll } from 'react-remove-scroll';

export interface ModalProps {
  onClose: () => void;
  scrollableContentWrapperId?: string;
}

const Modal: React.FC<ModalProps> = ({
  children,
  onClose,
  scrollableContentWrapperId,
}) => {
  return (
    <RemoveScroll>
      <div className={styles.container}>
        <div className={styles.background} />
        <div className={styles.contentWrapper}>
          <span className={styles.close}>
            <ActionButton
              type="icon"
              icon={{
                source: crossIcon,
                size: 'large',
              }}
              onClick={onClose}
            />
          </span>
          <div
            className={styles.content}
            id={scrollableContentWrapperId}
            onClick={e => e.stopPropagation()}
          >
            {children}
          </div>
        </div>
      </div>
    </RemoveScroll>
  );
};

export default Modal;
